export enum MutationKey {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  RECOVER_PASSWORD = 'RECOVER_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  CREATE_VACANCY = 'CREATE_VACANCY',
  DELETE_VACANCY = 'DELETE_VACANCY',
  EDIT_VACANCY = 'EDIT_VACANCY',
  UPDATE_VACANCY_RESPONSIBLE = 'UPDATE_VACANCY_RESPONSIBLE',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_USERS = 'DELETE_USERS',
  CREATE_USER = 'CREATE_USER',
  STORAGE_UPLOADS_AVATARS = 'STORAGE_UPLOADS_AVATARS',
  STORAGE_UPLOADS_VIDEOS = 'STORAGE_UPLOADS_VIDEOS',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  UPDATE_CANDIDATE = 'UPDATE_CANDIDATE',
  UPDATE_CANDIDATE_STATUS = 'UPDATE_CANDIDATE_STATUS',
  UPDATE_CANDIDATE_INTERVIEW = 'UPDATE_CANDIDATE_INTERVIEW',
  UPDATE_CANDIDATE_EMPLOYMENT_DATE = 'UPDATE_CANDIDATE_EMPLOYMENT_DATE',
  CREATE_COMPANY = 'CREATE_COMPANY',
  UPDATE_ACTIVITY_COMPANY = 'UPDATE_ACTIVITY_COMPANY',
  UPDATE_ARCHIVE_COMPANY = 'UPDATE_ARCHIVE_COMPANY',
  UPDATE_USER_ACTIVITY = 'UPDATE_USER_ACTIVITY',
  UPDATE_VACANCY_STATUS = 'UPDATE_VACANCY_STATUS',
  CREATE_VACANCY_TEMPLATE = 'CREATE_VACANCY_TEMPLATE',
  UPDATE_VACANCY_TEMPLATE = 'UPDATE_VACANCY_TEMPLATE',
  DELETE_VACANCY_TEMPLATE = 'DELETE_VACANCY_TEMPLATE',
  UPDATE_VACANCY_TEMPLATE_ACTIVITY = 'UPDATE_VACANCY_TEMPLATE_ACTIVITY',
  UPDATE_AI_CONSTANT = 'UPDATE_AI_CONSTANT',
  EXPORT_VACANCY = 'EXPORT_VACANCY',
  CREATE_VACANCY_COPY = 'CREATE_VACANCY_COPY',
  GET_VACANCY_COPY = 'GET_VACANCY_COPY',
  GENERATE_VACANCY = 'GENERATE_VACANCY',
  SEND_USER_AI_MESSAGE = 'SEND_USER_AI_MESSAGE',
  VERIFY_COMPANY_NCC = 'VERIFY_COMPANY_NCC',
  CONFIRM_COMPANY_NCC = 'CONFIRM_COMPANY_NCC',
}
